import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const finishRender: GraphCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    if (!draft.longRenderingLocked) {
      draft.longRendering = false;
    }
  });
};
